import "./AcadmicCard.css";
function AcadmicCard(props) {
  return (
    <div className="card">
      <h3>{props.CourseName}</h3>
      <p>From : {props.From}</p>
      <p>Date : {props.Date}</p>
      {props.Credential ? (
        <a href={props.Credential} target="_blank" rel="noreferrer">
         <button> View Certificate </button>
        </a>
      ) : (
        ""
      )}
      <img src={props.Img} alt="From" />
    </div>
  );
}

export default AcadmicCard;
